var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-wrapper flex flex-wrap"},_vm._l((_vm.steps),function(v,i){return _c('div',{key:i,staticClass:"step",class:{
      active: _vm.step === i + 1,
      prev: i < _vm.step,
      disabled: (_vm.disabledNext && i + 1 > _vm.step) || (_vm.disabledFirst && i === 0)
    },on:{"click":function($event){return _vm.swichPage(v.link, i)}}},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(i + 1))]),_c('span',[_vm._v(_vm._s(v.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }